import { render, staticRenderFns } from "./MentorGroupsStatsCpt.vue?vue&type=template&id=189c9534&scoped=true&"
import script from "./MentorGroupsStatsCpt.vue?vue&type=script&lang=ts&"
export * from "./MentorGroupsStatsCpt.vue?vue&type=script&lang=ts&"
import style0 from "./MentorGroupsStatsCpt.vue?vue&type=style&index=0&id=189c9534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c9534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
